import styles from '../CommonCss/OrderEngineCommon.module.css'
import ModalWindow from "../../../FormTemplate/ModalWindow/ModalWindow";
import MainFormTemplate from "../../../FormTemplate/MainFormTemplate/MainFormTemplate";
import InputItem from "../../../FormTemplate/InputItem/InputItem";
import ErrorLineItem, {ErrorLineItemRef} from "../../../FormTemplate/ErrorLineItem/ErrorLineItem";
import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../../ApiQuery/UseApiQuery";
import SelectUnit, {SelectUnitDataInt} from "../../../FormTemplate/SelectUnit/SelectUnit";
import WaitLoader from "../../../WaitLoader/WaitLoader";


interface UpdateOrderInt
{
    orderId:string
    id?:number
    fieldList: string[]
    valList: any[]
    mode:number
}

interface OrderEngineStatePropsInt
{
    orderId:string
    pTrack: string
    onClose: ()=>void
    onSuccess?: ()=>void


}

interface StateListInt
{
    name: string
    state: number
}

export default function OrderEngineTrack({orderId,onClose,onSuccess,pTrack}:OrderEngineStatePropsInt){




    const orderUpdateData = useRef<UpdateOrderInt>()
    const [ldrOrderUpdate,rsOrderUpdate,exOrderUpdate] = useApiQuery("/sell/sim/order/update/field","post",orderUpdateData);

    const [track, setTrack] = useState(pTrack)
    const updateTrack = useRef<ErrorLineItemRef>(null)
    const [valid, setValid] = useState(false)

    useEffect(()=>{
        const vTrack = track?.match(/^[0-9_a-z]{5,30}$/ui)
        if(vTrack ) setValid(true)
        else setValid(false)


    },[track])




    const handleUpdate = () =>{
        orderUpdateData.current = {
            orderId: orderId,
            mode:2,

            fieldList: ["track"],
            valList:[track]
        }
        exOrderUpdate().then((e)=>{
            if(e?.success)
            {
                if(updateTrack.current)updateTrack.current.show(`Трэк заказа ${orderId} обновлен`,false,0)
                if(onSuccess) onSuccess()
                return
            }
            if(updateTrack.current)updateTrack.current.show(e?.errorAsString ? e?.errorAsString :"Ошибка сервера",true,3000)
        }).catch((e)=>{
            if(updateTrack.current)updateTrack.current.show(e?.errorAsString ? e?.errorAsString :"Ошибка сервера",true,3000)

        })

    }


    return(
        <ModalWindow>
            <MainFormTemplate title={`Изменить статус`} maxWidth={"400px"} background={"white"}>
                <div className={"row"}>
                    <div className={"col-sm-12"}>
                        <InputItem
                            val={track }
                            info={"Трэк"}
                            mode={"ei"}
                            title={"Трэк"}
                            onChange={(e)=> setTrack(e)}

                        ></InputItem>
                    </div>
                </div>
                <ErrorLineItem ref={updateTrack} ></ErrorLineItem>

                <div className={styles.actCont}>
                    <div className={styles.btnCont}>
                        <button type="button" className="btn btn-secondary "
                                disabled={!valid}
                                onClick={(e)=>{
                                    handleUpdate()
                                }}
                        >Обновить</button>
                    </div>
                    <div className={styles.btnCont}>
                        <button type="button" className="btn btn-secondary "
                                onClick={(e)=>{
                                    onClose()
                                }}
                        >Закрыть</button>
                    </div>
                    <WaitLoader loading={ldrOrderUpdate } api={rsOrderUpdate} onlyLoading={true}>

                    </WaitLoader>

                </div>

            </MainFormTemplate>
        </ModalWindow>
    )
}